function preprocessTimeColumnsExclusionSets(schema) {
  const { ExclusionSets } = schema;
  // skip if it has been polyfilled
  if (!('DimensionColumns_TimeCategory' in ExclusionSets)) {
    ExclusionSets.DimensionColumns_TimeCategory = ['Week'];
    ExclusionSets.MetricColumns_TimeCategory = ['WeekStartingMonday'];
  }
}

export function preprocessReportSchemaForTimeColumns(reportSchema) {
  preprocessTimeColumnsExclusionSets(reportSchema);
}
